const products = {
  "Cushion Printed - Van Gogh - dual side printed": 399,
  "Rechargeable Bunny Lamp": 1099,
  "Rechargeable Pear Lamp": 999,
  "Cat Lamp": 799,
  "Rechargeable Panda Lamp": 999,
  "Lord Hanuman Statue": 999,
  "Lord Ganesha Statue": 699,
  "Owl Supercute Bag": 1999,
  "Supercute Bag": 3999,
  "Astro Supercute Bags": 2499,
  "Lord Buddha Head Statue": 1699,
  "Animal Popout Hook": 249,
  "Marble Print Plant": 399,
  "Dog Artificial Planter": 299,
  "Toothpick Dispenser": 79,
  "Cable Holder - Pack of 4": 99,
  "Gold Marble Print Planter": 499,
  "Dog Artifical Planter": 299,
  "Cylinderical Crystal Lamp": 699,
  "Rechargeable Hedgehog Lamp": 1499,
  "Shampoo Dispenser": 599,
  "Bathroom Ceramic - Marble Print - Set of 4": 1099,
  "Premium Bathroom Ceramic - Set of 4": 1099,
  "Metal Hangers - Set of 10": 249,
  "Wooden Hangers - Set of 2": 249,
  "Detergent Tin Box": 499,
  "Retractable Clothsline String": 649,
  "Bath Sponge": 99,
  "Lunch Bag": 459,
  "Smiley Lunch Bag": 499,
  "Kids Duck Lunchbox": 649,
  "Cork Sphere Glass Container": 499,
  "Vacum Pot": 1099,
  "Sphere Ice Tray - Large": 699,
  "Mini Sphere Ice Tray": 149,
  "Premium Office Lunch Box": 999,
  "Ceramic Printed Teapot": 799,
  "Silicone Cookware Set - Set Of 11": 1199,
  "Bento Lunch box": 799,
  "Kawai Elf Table Lamp": 799,
  "Table Clock": 599,
  "Compressible Bottles - Food Theme": 599,
  "Compressible Bottles": 599,
  "Sipper Bottle - 1.3L": 549,
  "Donut Bottle - 380 ML": 699,
  "First Aid Box": 299,
  "Travel Medicine Box": 149,
  "Bear Supercute Bag": 2499,
  "Piggy Supercute Backpack": 1999,
  "Animal Series Supercute Bag": 1699,
  "Lady Bug Supercute bag": 1999,
  "2D Bags": 999,
};

const orgDetails = {
  orgName: "TRICKYWAVE INFOTECH PRIVATE LIMITED",
  orgAddress:
    "Shop No. G-27, Ground Floor, Fashion Mall, Road No. 43, Pitampura, North West Delhi, Delhi. 110034",
  gstNumber: "07AALCT0726A1ZP",
  phoneNumber: "+91 8878547678",
};

const shortName = "TW";

const wavepay = { products, orgDetails, shortName };
export default wavepay;
